import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail, ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../api/client";
import { ScanEyeLogoPrueba } from "../components/ScanEyeLogoPrueba";

export default function ForgotPasswordPrueba() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      toast.error("Introduce un email válido");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Solicitud recibida");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(formatApiError(detail) || "No se pudo procesar la solicitud");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white relative overflow-hidden">
      <div className="absolute inset-0 radial-bg pointer-events-none" />
      <div className="absolute inset-0 scan-grid opacity-20 pointer-events-none" />
      <div className="relative max-w-md mx-auto px-6 py-8 min-h-screen flex flex-col justify-center">
        <Link to="/login" className="inline-flex items-center gap-2 text-sm text-[#8A8F98] hover:text-[#DEFF9A] mb-10">
          <ArrowLeft size={16} /> Volver al acceso
        </Link>

        <ScanEyeLogoPrueba size="lg" className="mb-10" />

        <div className="rounded-3xl border border-[#1F2428] bg-[#0A0A0A]/90 p-6 sm:p-8 shadow-2xl">
          <div className="w-12 h-12 rounded-2xl bg-[#DEFF9A]/10 border border-[#DEFF9A]/30 flex items-center justify-center mb-5">
            <ShieldCheck size={22} className="text-[#DEFF9A]" />
          </div>
          <h1 className="font-display text-3xl tracking-tighter mb-2">Recuperar contraseña</h1>
          <p className="text-sm text-[#8A8F98] leading-relaxed mb-6">
            Introduce el email de tu cuenta. Si el backend tiene activado el envío, recibirás instrucciones seguras para restablecer el acceso.
          </p>

          {!sent ? (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="relative">
                <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#5A5F68]" />
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="tu@empresa.com"
                  className="se-input w-full bg-black border border-[#1F2428] rounded-xl pl-11 pr-4 py-3 text-white placeholder:text-[#5A5F68] outline-none"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#DEFF9A] hover:bg-[#C8FF6E] text-black font-bold rounded-xl py-3 transition-colors flex items-center justify-center gap-2 disabled:opacity-60 glow-acid"
              >
                {loading && <Loader2 size={16} className="animate-spin" />}
                Enviar recuperación
              </button>
            </form>
          ) : (
            <div className="rounded-2xl border border-[#DEFF9A]/25 bg-[#DEFF9A]/10 p-5">
              <p className="text-sm text-[#DEFF9A] font-semibold mb-1">Solicitud registrada</p>
              <p className="text-sm text-[#8A8F98]">Revisa tu correo y sigue las instrucciones para recuperar el acceso.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

